import React from 'react'
import { Form, } from 'antd'
import { connect } from 'react-redux'
import styles from '../../../styles'
import { withStyles } from '@material-ui/core/styles'
import { isInteger, isFloat } from '../../../functions'
import _ from 'lodash'
import { Input, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

export class ApplicationDataEditor extends React.Component {


    handleValueChange = (type, newValue, index, field) => {
        if (type && ((type.toLowerCase() === 'integer' && isInteger(newValue)) || (type.toLowerCase() === 'float' && isFloat(newValue)) || type.toLowerCase() === 'string')) {

            let values = this.getValues()
            if (type.toLowerCase() === 'integer') {
                values[index][field] = newValue
            }
            else if (type.toLowerCase() === 'float') {
                values[index][field] = newValue
            }
            else {
                values[index][field] = newValue
            }

            if (this.props.onUpdate) {
                this.props.onUpdate(values)
            }
        }
    }

    getValues = () => {
        const dataFields = this.props.solution.applicationDatasetFields
        const data = this.props.solution.applicationTestData || []
        let retFields =  dataFields ?
            dataFields.map(item => {
                const field = _.find(data, ['key', item.key])
                const value = field?field.value:''
                return {
                ...item,
                value: value,
                }
        }) :[]
        return retFields
    }

    render() {

        const values = this.getValues()
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding='none'>Name</TableCell>
                        <TableCell padding='none'>Type</TableCell>
                        <TableCell padding='none'>Value</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {values.map((row, index) => {
                        return (
                            <TableRow key={row.key}>
                                <TableCell component="th" scope="row" padding='none' classes={{ root: this.props.classes.scoreCardCellRoot }}>
                                    {row.name}
                                </TableCell>
                                <TableCell padding='none' classes={{ root: this.props.classes.scoreCardCellRoot }}>
                                    {row.type}
                                </TableCell>
                                <TableCell padding='none' classes={{ root: this.props.classes.scoreCardCellRoot }}>
                                    <Input value={row.value} onChange={(e) => this.handleValueChange(row.type, e.target.value, index, 'value')} style={{ width: '100%' }} />
                                </TableCell>

                            </TableRow >
                        )
                    }
                    )}
                </TableBody>
            </Table>)
    }
}

ApplicationDataEditor = Form.create()(connect(
    (state, props) => ({
        solution: state.solutions.present.items[props.id] && state.solutions.present.items[props.id]._embedded
    }),
    null
)(withStyles(styles, { withTheme: true })(ApplicationDataEditor)))


// WEBPACK FOOTER //
// ./src/App/SolutionEditor/SolutionDiagramEditor/ApplicationDataEditor.jsx